<template>
	<div class="logon">
		<div class="logon_header w1200 flex">
			<router-link to="/" class="logon_header_logo flex"><img :src="public.top_logo" class="block" /><span class="f20px">&nbsp;&nbsp;&nbsp;&nbsp;·&nbsp;&nbsp;&nbsp;&nbsp;在线购卡</span></router-link>
			<div class="logon_header_r tc f16px">
				<router-link to="/" class="logon_header_list cl_dark">
					<img src="../../static/icon_index.png" />
					<p>返回首页</p>
				</router-link>
				<router-link to="/personal" class="logon_header_list cl_dark">
					<img src="../../static/icon_personal.png" />
					<p>个人中心</p>
				</router-link>
			</div>
		</div>
		<div class="vip_buy">
			<div class="w1200">
				<div class="vip_buy_cont">
					<div class="vip_buy_top bg_white radius8">
						<!-- <div class="vip_need mab30">
							<div class="vip_title f20px cl_dark">购买须知</div>
							<div class="vip_need_cont cl_gray mat20" v-html="vip_need"></div>
						</div> -->
						<div class="explain">
							<div class="vip_title f20px cl_dark">会员权限说明</div>
							<table class="vip_table mat20">
								<tr class="f16px cl_white">
									<th width="80px">会员级别</th>
									<th>最多看多少个视频</th>
									<th>每个视频最多几分钟</th>
									<th>是否可以在线答题</th>
									<th>是否可以查看资讯</th>
									<th>是否可以查看新闻</th>
									<th>是否可以查看试卷</th>
									<th>是否可以查看付费视频</th>
									<th>会员价格</th>
									<th>有效期</th>
								</tr>
								<tr v-for="(item,index) in vip" :key="index" class="tc cl_dark">
									<td>{{item.name}}</td>
									<td>{{item.max_video_count == 0 ? '不限' : item.max_video_count}}</td>
									<td>{{item.max_video_minute == 0 ? '不限' : item.max_video_minute}}</td>
									<td>{{item.is_work == 1 ? '是' : '否'}}</td>
									<td>{{item.is_info == 1 ? '是' : '否'}}</td>
									<td>{{item.is_news == 1 ? '是' : '否'}}</td>
									<td>{{item.is_exam == 1 ? '是' : '否'}}</td>
									<td>{{item.is_pay_video == 0 ? '否' : (item.is_pay_video == 1 ? '是' : '需要购买')}}</td>
									<td>{{item.price}}</td>
									<td>{{item.period}}天</td>
								</tr>
							</table>
						</div>
						<div class="mat30">
							<div class="personal_item">
								<p class="personal_item_l f16px cl_gray"><span class="inline">省份选择</span><i class="inline">：</i></p>
								<div class="personal_item_r">
									<div class="famous_screen_list mat5">
										<el-select v-model="sd_value" placeholder="选择高考所在省份" class="f16px">
											<el-option v-for="item in sd":key="item.id" :label="item.name":value="item.id"></el-option>
										</el-select>
									</div>
								</div>
							</div>
							<div class="personal_item">
								<p class="personal_item_l f16px cl_gray"><span class="inline">套餐选择</span><i class="inline">：</i></p>
								<div class="personal_item_r">
									<div class="money_list bg_gray cl_gray tc" v-for="(item,index) in vip_list" :key="index" :class="{'on':item.id==vip_cur.id}" @click="vipSelect(index)">{{item.name}}</div>
								</div>
							</div>
							<div class="personal_item">
								<p class="personal_item_l f16px cl_gray"><span class="inline">支付方式</span><i class="inline">：</i></p>
								<div class="personal_item_r">
									<div class="radius8 cur buy_type_item" v-for="(item,index) in type" :key="index" :class="{'on': item.id == type_cur}" @click="type_cur = item.id">
										<img :src="item.pic" />
										<span v-if="item.name != ''" class="mal5">{{item.name}}</span>
										<img src="../../static/icon_checked.png" class="buy_type_item_tip" />
									</div>
								</div>
							</div>
							<div class="personal_item" v-if="type_cur == 1">
								<div class="personal_item_l f16px cl_gray"><span class="inline">账户余额</span><i class="inline">：</i></div>
								<div class="personal_item_r f20px cl_red">{{myInfo.balance}}</div>
							</div>
						</div>
					</div>
					<div class="vip_buy_btm tc mat50">
						<button type="button" class="cl_white" @click="buy">¥ <span class="f18px">{{vip_cur.price}}</span><span class="f18px">&nbsp;&nbsp;&nbsp;立即购买</span></button>
					</div>
				</div>
			</div>
		</div>
		<vfooter @child-event="parentEvent"></vfooter>
		<!-- 微信支付 -->
		<el-dialog title="微信支付" :visible.sync="wxShow" width="30%" :close-on-click-modal="false" :center="true" :destroy-on-close="true">
		  <div class="tc">
				<div class="qrcode inline" ref="qrCodeUrl"></div>
			</div>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="wxShow = false">取 消</el-button>
		    <el-button type="primary" @click="wxConfirm">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import vfooter from '../components/footer.vue'
	import QRCode from 'qrcodejs2'
	
	export default {
		name: 'vip_buy',
		components: {
		 vfooter,
		},
		props: {
			
		},
		data () {
			return {
				public: {},
				myInfo: {},
				vip_cur: {},
				vip: [],
				vip_list: [],
				sd_value: "", //属地
				sd: [],
				vip_need: "<p>1、您将购买的是会员升级,购买成功后自动升级为会员，有效期到2030年9月1日。</p><p>2、本卡志愿填报系统不适用于北京、天津、上海、青海、新疆、西藏及港澳台地区（注：海南只支持电脑使用，不支持手机APP使用）。</p><p>3、本卡志愿填报系统不适用于报考艺体类、军警类的同学。</p><p>4、由于产品特性，本电子卡不适用“7天无理由退换货”，请仔细阅读退款说明后进行购买。</p>",
				type: [
					{
						id: 1,
						pic: require("../../static/icon_balance.png"),
						name: "余额支付",
					},{
						id: 2,
						pic: require("../../static/payment_01.png"),
						name: "",
					},{
						id: 3,
						pic: require("../../static/payment_02.png"),
						name: "",
					},
				],
				type_cur: 1,
				wxShow: false, //微信支付
				order_no: "", //订单号
			}
		},
		created() {
			
		},
		mounted() {
			this.getVip();
			this.getInfo();
			this.getSd();
		},
		methods: {
			parentEvent (data) {
				this.public = data;
			},
			getInfo () {
				this.$get("/api/user/get_user_info",{
					token: localStorage.getItem("token")
				})
				.then(res => {
					this.myInfo = res.data;
				});
			},
			vipSelect (e) {
				this.vip_cur = this.vip_list[e];
			},
			getVip () {
				this.$get("/api/user/get_level_data",{})
				.then(res => {
					this.vip = res.data;
					for (let i = 0; i < res.data.length; i++) {
						if (res.data[i].price != "0.00" && res.data[i].price != "0") {
							this.vip_list.push(res.data[i])
						}
					}
					this.vip_cur = this.vip_list[0];
				});
			},
			//属地
			getSd () {
				this.$get("/api/careerbible/get_province_data",{})
				.then(res => {
					this.sd = res.data;
				});
			},
			//购买
			buy () {
				let return_url = "http://res.joy366.com/personal";
				if (this.type_cur == 2) {
					window.open('http://res.joy366.com/api/levelorder/add_level_order?token='+ localStorage.getItem("token") +'&id='+ this.vip_cur.id +'&type='+ this.type_cur +'&return_url='+ return_url + '&platform=1', '_blank');
				} else {
					this.$get("/api/levelorder/add_level_order",{
						token: localStorage.getItem("token"),
						id: this.vip_cur.id,
						type: this.type_cur,
						province_id: this.sd_value,
						return_url: return_url,
						platform: 1, //1pc;2h5;3app
					})
					.then(res => {
						if (this.type_cur == 1) {
							this.$message({
								duration: 1500,
								message: res.msg,
								type: 'success'
							});
							setTimeout(() => {
								this.$router.push({path: '/order', replace: true});
							}, 1500);
						} else if (this.type_cur == 3) {
							this.wxShow = true;
							this.order_no = res.data.order_no;
							setTimeout(() => {
								this.creatQrCode(res.data.code_url);
							}, 0);
						}
					});
				}
			},
			//生成二维码
			creatQrCode(url) {
				var qrcode = new QRCode(this.$refs.qrCodeUrl, {
					text: url,
					width: 250,
					height: 250,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.H
				})
			},
			wxConfirm () {
				this.$get("/api/levelorder/order_no_show",{
					token: localStorage.getItem("token"),
					order_no: this.order_no,
				})
				.then(res => {
					if (res.data == 0) {
						this.$message({
							duration: 1500,
							message: "请先扫描支付",
							type: 'warning'
						});
						return false
					} else if (res.data == 1) {
						this.$message({
							duration: 1500,
							message: res.msg,
							type: 'success'
						});
						setTimeout(() => {
							this.$router.push({path: '/order', replace: true});
						}, 1500);
					}
				});
			},
		},
	}
</script>

<style>
</style>
